import { motion } from "framer-motion";

const baseTransition = { duration: 1.0, ease: [0.22, 1, 0.36, 1] };

export function Reveal({ children, delay = 0, y = 24, blur = 8, className, as = "div", ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y, filter: `blur(${blur}px)` }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ ...baseTransition, delay }}
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
}

export function StaggerGroup({ children, className, stagger = 0.08 }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className, as = "div", y = 24, blur = 8 }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      variants={{
        hidden: { opacity: 0, y, filter: `blur(${blur}px)` },
        show: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 1.0, ease: [0.22, 1, 0.36, 1] } },
      }}
      className={className}
    >
      {children}
    </Comp>
  );
}
